import React, { useEffect, useState, useContext } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { LanguageContext } from "App";
import SessionSelector from "CinicComponents/SessionSelector";
const MultiPackageSession = ({ Patient, index, setPkgSession, setPricing }) => {
  const [Session, setSession] = useState({});
  const { translations } = useContext(LanguageContext);
  const [Quantity, setQuantity] = useState(1);
  const [OriginalPrice, setOriginalPrice] = useState(0);
  const [Discount, setDiscount] = useState(0);
  const [FinalPrice, setFinalPrice] = useState(0);
  const ShowPricing = () => {
    if (Object.keys(Session).length > 0 && Object.keys(Patient).length > 0) {
      return (
        <MDBox mt={4} mb={1}>
          <MDTypography
            className="patient-national-group-package"
            variant="button"
            fontWeight="regular"
            color="text"
          >
            <div className="single-session-discount">
              <div>
                <span style={{ color: "black" }}>
                  {translations.createmultiPackagePatientNationalityGroup}:
                </span>{" "}
                {Patient.nationalityGroup}
              </div>
              <div>
                <span style={{ color: "black" }}>
                  {translations.createAccountsessionSingleSessionSearchTableOriginalPrice}:
                </span>{" "}
                EGP{OriginalPrice}
              </div>
              <div>
                <span style={{ color: "black" }}>
                  {translations.createAccountsessionSingleSessionSearchTableFinalPrice}:
                </span>{" "}
                EGP{FinalPrice}
              </div>
              <div>
                <span style={{ color: "black" }}>
                  {translations.createAccountsessionSingleSessionSearchTableDiscount}:
                </span>{" "}
                %{Number(Discount).toFixed(1)}
              </div>
              <div>
                <span style={{ color: "black" }}>{translations.createmultiPackageTotal}:</span> EGP
                {FinalPrice * Quantity}
              </div>
            </div>
          </MDTypography>
        </MDBox>
      );
    }
  };

  const GetOriginalPrice = () => {
    if (Patient.nationalityGroup == "Egyptian") {
      setOriginalPrice(Session.egyptianPrice);
    } else if (Patient.nationalityGroup == "Arab") {
      setOriginalPrice(Session.arabPrice);
    } else if (Patient.nationalityGroup == "Other") {
      setOriginalPrice(Session.otherPrice);
    } else {
      setOriginalPrice("PRICE NOT FOUND");
    }
  };

  useEffect(() => {
    if (Object.keys(Session).length > 0 && Object.keys(Patient).length > 0) {
      GetOriginalPrice();
    }
  }, [Session, Patient]);

  useEffect(() => {
    if (Object.keys(Session).length > 0) {
      // setPkgSession(Session, Quantity, Discount, OriginalPrice, index);
      let pkgSession = {
        sessionId: Session.id,
        quantity: Quantity,
        finalPrice: FinalPrice,
        originalPrice: OriginalPrice,
      };
      setDiscount(((100 * (OriginalPrice - FinalPrice)) / OriginalPrice).toFixed(2));
      setPkgSession(pkgSession, index);
    }

    return () => {
      setPkgSession({}, index);
    };
  }, [Session, Quantity, FinalPrice]);

  if (!Patient || Object.keys(Patient).length < 1) {
    return (
      <MDBox>
        <MDTypography>
          {translations.CreateDomesticStayNumberofDaysPleaseselectapatient}
        </MDTypography>
      </MDBox>
    );
  }

  return (
    <MDBox pt={2} px={2}>
      <div className="session-selection">
        <MDBox>
          <SessionSelector setSession={setSession} Patient={Patient} />
        </MDBox>
        <MDBox className="quatntity-price-select">
          <MDInput
            className="quatntity-select"
            type={"number"}
            onChange={(e) => setQuantity(parseInt(e.target.value))}
            label={"Quantity"}
          ></MDInput>
          <MDInput
            type={"number"}
            onChange={(e) => setFinalPrice(parseFloat(e.target.value))}
            label={"Final Price"}
          ></MDInput>
        </MDBox>
      </div>
      <MDBox>{ShowPricing()}</MDBox>
    </MDBox>
  );
};

export default MultiPackageSession;
